module.exports = __webpack_public_path__ + "static/img/login-list-icon-google.ce3838d5.svg";